import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { REHYDRATE } from 'redux-persist';
import isEmpty from 'lodash/isEmpty';
import { DEFAULT_ROWS_PER_PAGE } from '@crema/constants';
import { ApiResult } from '@crema/models/Apps';
import { axiosBaseQuery } from './baseQuery';

export const optionTypeApi = createApi({
  reducerPath: 'optionType.api',
  baseQuery: axiosBaseQuery,
  // https://stackoverflow.com/questions/72687628/cannot-read-properties-of-undefined-reading-api-reducerpath-at-object-extrac
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === REHYDRATE) {
      return action.payload?.[reducerPath];
    }
  },
  tagTypes: ['optionTypes'],
  endpoints: (builder) => ({
    getOptionTypes: builder.query({
      query: ({ pageNo = 0, pageSize = DEFAULT_ROWS_PER_PAGE, name = '', category = '', unpaged = false }) => ({
        url: unpaged
          ? '/api/option-types?unpaged=true'
          : `/api/option-types?pageNo=${pageNo}&pageSize=${pageSize}&name=${name}` +
            (isEmpty(category) ? '' : `&category=${category}`),
      }),
      transformResponse: (response, meta: any) => {
        // console.log(response, meta);
        return {
          rows: response,
          totalCount: meta.totalCount,
        } as ApiResult;
      },
      keepUnusedDataFor: 5,
      providesTags: ['optionTypes'],
    }),
    addOptionType: builder.mutation({
      query: (body) => ({
        url: '/api/option-types',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['optionTypes'],
    }),
    deleteOptionType: builder.mutation({
      query: (id) => ({
        url: `/api/option-types/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['optionTypes'],
    }),
  }),
});

export const { useAddOptionTypeMutation, useGetOptionTypesQuery, useDeleteOptionTypeMutation } = optionTypeApi;
